import { Component } from 'react';

import Statistics from '../Statistics/Statistics';
import TitleHeader from '../TitleHeader/TitleHeader';

class Home extends Component {
    render() {
        return (
            <div>
                <TitleHeader title={'Statystyka'} />
                <Statistics />
            </div>
        );
    }
}

export default Home;
